import { MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { Component, OnInit, inject } from '@angular/core';
import { CdkScrollable } from '@angular/cdk/scrolling';

import { LogComponent } from '../log/log.component';
import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-modal-historique',
    template: `


<h1 mat-dialog-title>{{ data.title }}</h1>
<mat-dialog-content>
  @if (data) {
    <app-log [target]="data.target"></app-log>
  }
</mat-dialog-content>

<mat-dialog-actions>
  <button  mat-button [mat-dialog-close]="false">{{'general.close' | translate}}</button>
</mat-dialog-actions>


`,
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, LogComponent, MatDialogActions, MatButton, MatDialogClose, TranslateModule]
})
export class ModalHistoriqueComponent implements OnInit {
  data = inject<{
    target: string;
    title: string;
}>(MAT_DIALOG_DATA);


  public dossierId: number;


  ngOnInit() {
  }

}
